/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { ReactComponent as DownIcon } from 'assets/icons/down.svg'
import { useFormikContext } from 'formik'
import { Select } from 'antd'
import useDynamicDropdown from 'hooks/useDynamicDropdown'

const SelectParkingSlot = ({
  title = '',
  fieldName = '',
  placeholder = ''
}) => {
  const [parkingSlots] = useState([1, 2, 3])
  const { setFieldValue, values } = useFormikContext()
  const [dropDownOption, setDropDownOption] = useState([])
  const { data } = useDynamicDropdown(fieldName)
  useEffect(() => {
    if (data?.values) {
      setDropDownOption(data?.values.map((elm, index) => (
        {
          title: elm,
          value: parkingSlots[index]
        }
      )))
    }
  }, [data])

  return (
    <div key={fieldName} className='flex flex-1 flex-col justify-left'>
        <div className='font-bold text-softBlack_70 italic'>{title}</div>
        <Select
            suffixIcon={<DownIcon />}
            showArrow
            onChange={(e) => setFieldValue(fieldName, e)}
            defaultValue={values[fieldName]}
            placeholder={placeholder}
            className='rating-select text-sm bg-white border border-softBlack30 rounded text-softBlack placeholder-softBlack70 h-10'
        >
            {dropDownOption?.map(option => <Select.Option value={option.value}>
                <div className='flex gap-2 items-center'>
                    <span className='h-full'>{option.title}</span>
                </div>
            </Select.Option>)}
        </Select>
    </div>
  )
}

export default SelectParkingSlot
